{
  "version": 1,
  "asset_id": "d738a273-a392-4d86-8911-464d9d92747f",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/d738a273-a392-4d86-8911-464d9d92747f/comtecsa.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/d738a273-a392-4d86-8911-464d9d92747f/comtecsa.png",
  "original_filename": "comtecsa.png",
  "size": 31624,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:05Z"
}
